import axios from 'axios';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_ADDRESS,
  headers: new Headers(
    {
      'Content-Type': 'application/json',
    },
  ),
});

// httpClient.interceptors.response.use(
//   () => { },
//   async (error) => {
//     if (error.response.status === 401) {
//       const refreshToken = localStorage.getItem('refreshToken');
//       const { id } = JSON.parse(localStorage.getItem('user'));

//       const response = await httpClient.post('token', {
//         userId: id,
//         refreshToken,
//       });

//       if (response.status === 200) {
//         localStorage.setItem('token', response.data.token);
//         localStorage.setItem('refreshToken', response.data.refreshToken);
//       } else {

//       }
//     }

//     return error;
//   },
// );

export default httpClient;
